import { UserType } from 'store/slices/authSlice';
import { SnapshotDataType, SnapshotUserDataType } from 'types/snapshot';

import { SNAPSHOT_STATUS, SNAPSHOT_STATUS_LABELS } from './constants';

export const getSnapshotActorName = (actor: SnapshotUserDataType) => {
  const actorFirstName = actor?.first_name ?? actor?.related_first_name;
  const actorLastName = actor?.last_name ?? actor?.related_last_name;
  const actorLabel =
    actorFirstName || actorLastName
      ? `${actorFirstName ? actorFirstName.trim() : ''} ${actorLastName ? actorLastName.trim() : ''}`.trim()
      : actor?.email;

  return actorLabel || 'Further Support';
};

export const resolveSnapshotActor = (currentUser: UserType | null, item: SnapshotDataType) => {
  if (!currentUser || !item) return 'Further Support';

  const actor = item.updated_by ?? item.created_by;
  const isSystemSnapshot = item.shared;

  const isActorStaff = actor?.is_staff || actor?.is_superuser;

  if (isSystemSnapshot) {
    return 'via mystery shop';
  } else if (isActorStaff) {
    return 'by Further Support';
  }

  return getSnapshotActorName(actor);
};

export const getSnapshotStatusLabel = (snapshot: SnapshotDataType | undefined) => {
  if (!snapshot) return '';

  if (snapshot.draft) {
    return SNAPSHOT_STATUS_LABELS[SNAPSHOT_STATUS.DRAFT];
  } else if (snapshot.latest) {
    return SNAPSHOT_STATUS_LABELS[SNAPSHOT_STATUS.CURRENT];
  }

  return SNAPSHOT_STATUS_LABELS[SNAPSHOT_STATUS.HISTORICAL];
};
